const CYRILLIC_TO_LATIN: Record<string, string> = {
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  е: "e",
  ё: "e",
  ж: "zh",
  з: "z",
  и: "i",
  й: "i",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "h",
  ц: "ts",
  ч: "ch",
  ш: "sh",
  щ: "sch",
  ъ: "",
  ы: "y",
  ь: "",
  э: "e",
  ю: "yu",
  я: "ya",
};

const MAX_FIELD_NAME_LENGTH = 40;

export function transliterateToLatin(value: string): string {
  let result = "";
  for (const char of value) {
    const lower = char.toLowerCase();
    if (lower in CYRILLIC_TO_LATIN) {
      result += CYRILLIC_TO_LATIN[lower];
      continue;
    }
    result += char;
  }
  return result;
}

/** Ключ поля: `Дата рождения` → `data_rozhdeniya`. */
export function slugifyFieldName(source: string, fallback = "field"): string {
  const slug = transliterateToLatin(source)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, MAX_FIELD_NAME_LENGTH)
    .replace(/_+$/g, "");

  if (!slug) return fallback;
  if (/^[0-9]/.test(slug))
    return `${fallback}_${slug}`.slice(0, MAX_FIELD_NAME_LENGTH);
  return slug;
}

export function uniqueFieldName(
  existingNames: Iterable<string>,
  preferred: string,
): string {
  const used = new Set(
    [...existingNames].map((name) => name.trim()).filter(Boolean),
  );
  const base = slugifyFieldName(preferred);
  if (!used.has(base)) return base;

  for (let index = 2; index < 1000; index += 1) {
    const suffix = `_${index}`;
    const next = `${base.slice(0, MAX_FIELD_NAME_LENGTH - suffix.length)}${suffix}`;
    if (!used.has(next)) return next;
  }

  return `${base}_${Date.now().toString(36)}`.slice(0, MAX_FIELD_NAME_LENGTH);
}

export function suggestedFieldName(options: {
  label: string;
  type: string;
  existingNames: Iterable<string>;
}): string {
  const label = options.label.trim();
  const type = options.type.trim().toLowerCase() || "field";
  return uniqueFieldName(options.existingNames, label || type);
}
